module.exports = __webpack_public_path__ + "static/media/vanillaCupcake.7d7e5a4d.jpg";